import React, { useState } from 'react';
import { Tabs, Modal, Image } from 'antd';
import UploadMedia from './upload-media';
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import getImage from '../../helpers/getImage';
import ImageGallery from '../image-gallery';

const MediaUpload = ({
  imageList,
  setImageList,
  form,
  type,
  multiple = true,
  name,
  disabled,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const removeImg = (path) => {
    const nextArray = imageList.filter((item) => item !== path);
    form.setFieldsValue({
      images: nextArray,
    });
    setImageList(nextArray);
  };

  return (
    <>
      <div className='media-upload-wrapper'>
        {imageList?.map((item, idx) => (
          <div
            key={idx}
            className='image-wrapper'
            onClick={() => (disabled ? undefined : removeImg(item))}
          >
            <Image
              preview={true}
              src={getImage(item?.name)}
              className='images'
              alt={'images'}
            />
            <DeleteOutlined color='white' hidden={disabled} />
          </div>
        ))}
        {(multiple || !imageList.length) && (
          <div className='media-upload' onClick={showModal}>
            <PlusOutlined /> <span>Upload</span>
          </div>
        )}
      </div>
      <Modal
        onCancel={handleCancel}
        maskClosable={true}
        open={isModalOpen}
        footer={false}
        width={'80%'}
      >
        <Tabs
          items={[
            {
              key: 'item-1',
              label: 'Media files',
              children: (
                <UploadMedia
                  form={form}
                  setImageList={setImageList}
                  imageList={imageList}
                  setIsModalOpen={setIsModalOpen}
                  name={name}
                />
              ),
            },
            {
              key: 'item-2',
              label: 'Upload media',
              children: (
                <ImageGallery
                  type={type}
                  disabled={false}
                  form={form}
                  setFileList={setImageList}
                  fileList={imageList}
                  setIsModalOpen={setIsModalOpen}
                />
              ),
              className: 'upload-media',
            },
          ]}
        />
      </Modal>
    </>
  );
};
export default MediaUpload;
